/**************************************************************************************************/
/*   File: /src/app/shared/directives/drag-and-drop/drag-and-drop.directive.ts                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Directive, EventEmitter, HostBinding, HostListener, Output, Input } from '@angular/core';

/**
 * The drag and drop directive
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[nwplFrntDragAndDrop]'
})
export class DragAndDropDirective {

  /**
   * The disabled condition
   */
  @Input() disabled = false;

  /**
   * File over zone host binding
   */
  @HostBinding('class.file-over-zone') private fileOverZoneState = false;

  /**
   * Event emitter on dropFile
   * @type {EventEmitter<any>}
   * @memberof DragAndDropDirective
   */
  @Output() dropFile: EventEmitter<any> = new EventEmitter<any>();


  /**
   * Event emitter on file over the droppable area
   * @type {EventEmitter<any>}
   * @memberof DragAndDropDirective
   */
  @Output() fileOverZone: EventEmitter<any> = new EventEmitter<any>();


  /**
   * Event emitter for leave the dropping are
   * @type {EventEmitter<any>}
   * @memberof DragAndDropDirective
   */
  @Output() fileLeaveZone: EventEmitter<any> = new EventEmitter<any>();


  /**
   * Drag the file/img above the drag zone.
   * This function will execute untill the file above the drag zone.
   *
   * @param {*} event
   * @memberof DragAndDropDirective
   */
  /* istanbul ignore next */
  @HostListener('dragover', ['$event']) public onDragOver(event: any) {
    if (!this.disabled) {
      this.fileOverZoneState = true;
      this.fileOverZone.emit();
    }

    this._preventDefaultEventBehavior(event);
  }


  /**
   * Handler on file dragleave
   * @param {any} evt
   * @memberof DragAndDropDirective
   */
  /* istanbul ignore next */
  @HostListener('dragleave', ['$event']) public onDragLeave(event) {
    this._clear();
    this.fileLeaveZone.emit();

    this._preventDefaultEventBehavior(event);
  }


  /**
   * When you release the file/img over the drag zone.
   *
   * @param {any} evt
   * @memberof DragAndDropDirective
   */
  /* istanbul ignore next */
  @HostListener('drop', ['$event']) public onDrop(event) {

    if (!this.disabled) {
      const files = event.dataTransfer.files;

      if (files.length > 0) {
        this.dropFile.emit(files);
        this._clear();
        this.fileLeaveZone.emit();
      }
    }
    this._preventDefaultEventBehavior(event);
  }


  /**
   * Prevent default event behaviour
   * @param event
   */
  /* istanbul ignore next */
  private _preventDefaultEventBehavior(event) {
    event.preventDefault();
    event.stopPropagation();
  }


  /**
   * Clear the directive hostbinding manipulation.
   *
   * @private
   * @memberof DragAndDropDirective
   */
  /* istanbul ignore next */
  private _clear() {
    this.fileOverZoneState = false;
  }

}
